import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import NoticeRouter from "./notice/NoticeRouter";
import ContentRouter from "./content/ContentRouter";
import {RouterNavigationButton} from "../../RouterViews";

export default function HomeRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/contents/*'} element={<ContentRouter {...props} />} />
            <Route path={'/notices/*'} element={<NoticeRouter {...props} />} />
            <Route path={'/*'} element={<Navigation {...props} />} />
        </Routes>
    </>
}

function Navigation(props: RouterProps) {
    return <>
        <div className={props.styles.column8}>
            <RouterNavigationButton
                {...props}
                href={'/ui/home/contents/suggestions'}>
                홈 추천 콘텐츠
            </RouterNavigationButton>
            <RouterNavigationButton
                {...props}
                href={'/ui/home/contents/userProductions'}>
                홈 와글와글 콘텐츠
            </RouterNavigationButton>
            <RouterNavigationButton
                {...props}
                href={'/ui/home/notices'}>
                홈 공지사항
            </RouterNavigationButton>
        </div>
    </>
}